import React from "react";
import "./../../UaeAttestation/UaeAbout/UaeAbout.css";
import chinaAbout from "./../../../../vid_img/qatarAbout.jpg";
const ChinaAboutMain = () => {
  return (
    <div className="uaeAboutUsMainContainer">
      <div className="uaeAboutUsMainContent">
        <ul>
          <li>
            China is one of the popular nations to welcome individuals to work,
            stay, or perform business there. China attestation for document is a
            vital procedure that must be done if you are willing to travel to
            China. China attestation in Bangalore includes documents such as
            educational documents, personal documents, & commercial documents.
          </li>
          <li>
            It is a part of reliability that ensures the China government of
            your trustworthiness. It also shall build trust between the employee
            and employer or two businessmen if you are travelling for business
            or work. It is a prerequisite part of the authentication process
            which will verify the authenticity of your documents.
          </li>
          <li>
            You can get an attestation in Bangalore for China at
            Goodwayattestation which is approved by Ministries & embassies in
            India as well as abroad. We provide you best quality services & will
            complete the entire procedure of your document attestation with
            ease.
          </li>
          <li>
            You need to get your documents attested by the Embassy of Saudi
            Arabia to as part of your travel visa application process. Goodway
            Attestation makes your task simpler by getting your documents
            attested by the Embassy of Saudi Arabia, in Bengaluru itself. Be
            assured that the fees for attesting your papers are nominal!
          </li>
        </ul>
      </div>
      <div className="uaeAboutUsMainContentImg">
        <img src={chinaAbout} alt="chinaAbout" />
      </div>
    </div>
  );
};

export default ChinaAboutMain;
